import { useCallback } from 'react';
import { sessionsDB } from '../lib/supabase';

/**
 * APEX v8.18 — useSessions
 *
 * Encapsule tous les handlers CRUD des sessions :
 *   - autoGroupSession  : création automatique (depuis SessionsManagerModal)
 *   - closeSession      : fermeture de session en cours
 *   - deleteSession     : suppression
 *   - updateSession     : mise à jour (notes, titre...)
 */
export function useSessions({ sessions, setSessions, setShowSessionClose }) {
  // ============ AUTO GROUP SESSION ============
  const autoGroupSession = useCallback(async (sessionData) => {
    const saved = await sessionsDB.add(sessionData);
    setSessions(prev =>
      [saved, ...prev].sort((a, b) => new Date(b.closed_at) - new Date(a.closed_at))
    );
  }, [setSessions]);

  // ============ CLOSE SESSION ============
  const closeSession = useCallback(async (sessionData) => {
    const saved = await sessionsDB.add(sessionData);
    setSessions(prev => [saved, ...prev]);
    setShowSessionClose(false);
  }, [sessions, setSessions, setShowSessionClose]);

  // ============ DELETE SESSION ============
  const deleteSession = useCallback(async (id) => {
    await sessionsDB.delete(id);
    setSessions(prev => prev.filter(s => s.id !== id));
  }, [setSessions]);

  // ============ UPDATE SESSION ============
  const updateSession = useCallback(async (id, updates) => {
    const updated = await sessionsDB.update(id, updates);
    setSessions(prev => prev.map(s => s.id === id ? updated : s));
  }, [setSessions]);

  return { autoGroupSession, closeSession, deleteSession, updateSession };
}
